module.exports = __webpack_public_path__ + "assets/img/00076.fafb5be9.png";